const NAV_ACTIVE_CLASS = 'js--nav-active';

/**
 * Toggle navigation's background theme color
 * based on the active nav link.
 */
class Nav {
  constructor() {
    this.navItems = Array.from(document.querySelectorAll('.js-nav-item'));
    this.siteNav = document.querySelector('.js-site-nav');

    this.initialize();
  }

  initialize() {
    this.navItems.forEach(item => {
      /**
       * When tab focus or cursor ENTERS link,
       * add active class to navigation.
       */
      ['focusin', 'mouseover'].forEach(event => {
        item.addEventListener(event, () => {
          this.siteNav.classList.add('active');
          document.body.classList.add(NAV_ACTIVE_CLASS);
        });
      });

      /**
       * When tab focus or cursor LEAVES link,
       * remove active class from navigation.
       */
      ['focusout', 'mouseout'].forEach(event => {
        item.addEventListener(event, () => {
          if (!item.contains(document.activeElement)) {
            this.siteNav.classList.remove('active');
            document.body.classList.remove(NAV_ACTIVE_CLASS);
          }
        });
      });
    });
  }
}

export default Nav;
